import React from "react";
import "./AnalysisLegend.css";

function AnalysisLegend({ isVisible, onClose }) {
  return (
    <div
      id="analysis-legend"
      className={`analysis-legend ${isVisible ? "" : "hidden"}`}
    >
      <button id="legend-close-btn" onClick={onClose}>
        &times;
      </button>
      <h4>Analysis Legend</h4>
      <div className="legend-item">
        <div
          className="legend-color-box"
          style={{ backgroundColor: "rgba(255, 165, 0, 0.5)" }}
        ></div>
        <span>Buildings</span>
      </div>
      <div className="legend-item">
        <div
          className="legend-color-box"
          style={{ backgroundColor: "rgba(34, 139, 34, 0.5)" }}
        ></div>
        <span>Green Spaces</span>
      </div>
      <div className="legend-item">
        <div
          className="legend-color-box"
          style={{ backgroundColor: "rgba(70, 130, 180, 0.6)" }}
        ></div>
        <span>Water Bodies</span>
      </div>
      <div className="legend-item">
        <div
          className="legend-color-box"
          style={{ backgroundColor: "rgba(255, 192, 203, 0.5)" }}
        ></div>
        <span>Residential Zones</span>
      </div>
      <div className="legend-item">
        <div
          className="legend-color-box"
          style={{ backgroundColor: "rgba(218, 112, 214, 0.5)" }}
        ></div>
        <span>Commercial Zones</span>
      </div>
      <div className="legend-item">
        <div
          className="legend-color-box"
          style={{ backgroundColor: "rgba(128, 128, 128, 0.5)" }}
        ></div>
        <span>Industrial Zones</span>
      </div>
    </div>
  );
}

export default AnalysisLegend;
